"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * class used for automatically refresh the token.
 * the refreshtoken method is auomatically triggered in case the user interacted with the page within the last 15 minutes before token expiration
 */
/**
 * auto refresh minutes interval
 */
var CONSIDER_INTERACTION_MINUTES_INTERVAL = 15;
var ONE_MIN_MS = 60000;
var USER_INTERACTION_EVENTS = ['keyup', 'mousemove'];
var TokenAutoRefresh = /** @class */ (function () {
    function TokenAutoRefresh() {
        var _this = this;
        /**
         * store the list of token auto refresh parameters (multiple client support)
         */
        this.autoRefreshParameters = null;
        /**
         * method called every time the user interacted with the dom
         * if ignoreUserInteractionTimerId, the interaction will be ignored otherwise create the autorefresh timer and remove the custom user interaction handler
         */
        this.onUserInteraction = function () {
            if (!_this.ignoreUserInteractionTimerId) {
                return;
            }
            _this.initializeRefreshTokenLastMinuteInterval();
        };
    }
    /**
     * starts the autorefresh flow
     * @param autoRefreshParameters {ITokenAutoRefreshParams} parameters used for auto refresh flow
     */
    TokenAutoRefresh.prototype.startAutoRefreshFlow = function (autoRefreshParameters) {
        var _this = this;
        if (!autoRefreshParameters) {
            return;
        }
        this.autoRefreshParameters = autoRefreshParameters;
        var expire = autoRefreshParameters.expire;
        if (!expire) {
            return;
        }
        this.stopTimer(this.autoRefreshTimerId);
        this.autoRefreshTimerId = 0;
        this.initializeIgnoreUserInteractionInterval(expire);
        USER_INTERACTION_EVENTS.forEach(function (eventName) { return _this.initializeDomEvent(eventName); });
    };
    /**
     * initialize the ignore user interaction interval
     * @param expire
     */
    TokenAutoRefresh.prototype.initializeIgnoreUserInteractionInterval = function (expire) {
        var _this = this;
        this.stopTimer(this.ignoreUserInteractionTimerId);
        this.ignoreUserInteractionTimerId = 0;
        var ignoreUserInteractionTime = this.getIgnoreUserInteractionInterval(expire);
        this.ignoreUserInteractionTimerId = setTimeout(function () {
            _this.stopTimer(_this.ignoreUserInteractionTimerId);
        }, ignoreUserInteractionTime);
    };
    /**
     * initialize the autorefresh timer which will trigger the refresh token
     */
    TokenAutoRefresh.prototype.initializeRefreshTokenLastMinuteInterval = function () {
        var _this = this;
        if (this.autoRefreshTimerId) {
            return;
        }
        this.autoRefreshTimerId = setTimeout(function () {
            var _a;
            _this.stopTimer(_this.autoRefreshTimerId);
            _this.autoRefreshTimerId = 0;
            (_a = _this.autoRefreshParameters) === null || _a === void 0 ? void 0 : _a.refreshTokenMethod();
        }, this.getMSTimeTillCallRefreshMethod());
    };
    TokenAutoRefresh.prototype.getMSTimeTillCallRefreshMethod = function () {
        if (!this.autoRefreshParameters) {
            return 0;
        }
        return this.autoRefreshParameters.expire.getTime() - new Date().getTime() - ONE_MIN_MS;
    };
    /**
     * initialize the dom event
     * @param expiration represents the Date when the token will expire
     */
    TokenAutoRefresh.prototype.initializeDomEvent = function (eventName) {
        window.removeEventListener(eventName, this.onUserInteraction);
        window.addEventListener(eventName, this.onUserInteraction);
    };
    /**
     * add minutes value to date and returns the new date value
     * @param date represents the inout date
     * @param minutes contains the minutes which will be added to the date
     */
    TokenAutoRefresh.prototype.addMinutes = function (date, minutes) {
        return new Date(date.getTime() + minutes * ONE_MIN_MS);
    };
    /**
     * returns the miliseconds interval when the user interaction should be ignored
     * the ignore interval should be less than 15 minutes before token expiration
     * @param expire represents the token expire date;
     */
    TokenAutoRefresh.prototype.getIgnoreUserInteractionInterval = function (expire) {
        var ignoreInteraction = this.addMinutes(expire, -CONSIDER_INTERACTION_MINUTES_INTERVAL - 1);
        return ignoreInteraction.getTime() - (new Date).getTime();
    };
    /**
     * clear the timeout timer id
     * @param timer represents the timer id which it will be cleared
     */
    TokenAutoRefresh.prototype.stopTimer = function (timer) {
        if (!timer) {
            return;
        }
        clearTimeout(timer);
    };
    return TokenAutoRefresh;
}());
exports.default = new TokenAutoRefresh();
